import { createSlice } from '@reduxjs/toolkit';
const SLICE_NAME = 'buyTopModalSlice';

export const buyTopModalSlice = createSlice({
    name: SLICE_NAME,
    initialState: {
        isOpen: false,
    },
    reducers: {
        toggleBuyTopModal(state) {
            state.isOpen = !state.isOpen;
        },
    },
});

export const { toggleBuyTopModal } = buyTopModalSlice.actions;

export const buyTopModalStateSelector = (state) => state.buyTopModal.isOpen;

export const buyTopModal = buyTopModalSlice.reducer;
